import { gql } from '@apollo/client';
import { CORE_PLAYLIST_FIELDS } from './fragments';

export const deletePlaylist = gql`
  mutation deletePlaylist($playlistId: ID!) {
    deletePlaylist(id: $playlistId) {
      id
    }
  }
`;

export const createPlaylist = gql`
  ${CORE_PLAYLIST_FIELDS}
  mutation createPlaylist($input: CreatePlaylistInput!) {
    createPlaylist(input: $input) {
      ...CorePlaylistFields
    }
  }
`;

export const sendPlaylistReminder = gql`
  mutation sendPlaylistReminder($playlistId: ID!) {
    sendPlaylistReminder(playlistId: $playlistId) {
      id
      lastReminderAt
    }
  }
`;

export const updatePlaylist = gql`
  ${CORE_PLAYLIST_FIELDS}
  mutation updatePlaylist($input: UpdatePlaylistInput!) {
    updatePlaylist(input: $input) {
      ...CorePlaylistFields
    }
  }
`;

export const transferPlaylist = gql`
  ${CORE_PLAYLIST_FIELDS}
  mutation transferPlaylist($input: TransferPlaylistInput!) {
    transferPlaylist(input: $input) {
      ...CorePlaylistFields
    }
  }
`;
